/* LG Wishlist : liste de produits enregistrés sur cet appareil. */
(() => {
  'use strict';
  const KEY = 'lg-wishlist-lab-items-v1';
  const LIMIT = 40;
  const BASE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ROOT = BASE.endsWith('/') ? BASE : BASE + '/';
  const HANDLE = /^[a-z0-9][a-z0-9-]*$/;
  const ID = /^\d{1,20}$/;

  function read() {
    try {
      const items = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(items) ? items.filter(x => x && HANDLE.test(x.handle || '') && ID.test(String(x.variant_id))).slice(0, LIMIT) : [];
    } catch(e) { return []; }
  }
  function save(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('lg:wishlist-lab:changed', {detail:{count:items.length}}));
      return true;
    } catch(e) { return false; }
  }
  function parse(value) {
    const s = String(value || '').trim();
    if (HANDLE.test(s)) return {handle:s, variant:null};
    try {
      const u = new URL(s, location.origin);
      if (u.origin !== location.origin) return null;
      const match = u.pathname.match(/(?:^|\/)products\/([a-z0-9][a-z0-9-]*)(?:\/)?$/i);
      if (!match) return null;
      const variant = u.searchParams.get('variant');
      return {handle:match[1].toLowerCase(), variant:variant && ID.test(variant) ? variant : null};
    } catch(e) { return null; }
  }
  function preview() {
    const id = new URL(location.href).searchParams.get('preview_theme_id');
    return id && ID.test(id) ? '&preview_theme_id=' + encodeURIComponent(id) : '';
  }
  function key(item) { return item.handle + '|' + String(item.variant_id); }
  function removeControl(item) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lg-wishlist-lab__remove text-sm text-subdued';
    btn.textContent = this.removeLabel || 'Retirer de ma sélection';
    btn.dataset.lgRemove = key(item);
    btn.setAttribute('aria-label', (this.removeLabel || 'Retirer de ma sélection') + ' : ' + item.handle);
    return btn;
  }
  async function ajaxCard(item) {
    const url = ROOT + 'products/' + encodeURIComponent(item.handle) +
      '?section_id=lg-wishlist-card&variant=' + encodeURIComponent(item.variant_id) + preview();
    const response = await fetch(url, {credentials:'same-origin'});
    if (!response.ok) throw new Error('Section non disponible');
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = parsed.querySelector('product-card.product-card');
    if (!node) throw new Error('Carte indisponible');
    return node;
  }
  function unavailable(item) {
    const box = document.createElement('div');
    box.className = 'lg-wishlist-lab__unavailable';
    const text = document.createElement('p');
    text.className = 'text-sm text-subdued';
    text.textContent = (this.unavailableLabel || 'Fiche indisponible') + ' : ' + item.handle;
    const link = document.createElement('a');
    link.href = ROOT + 'products/' + encodeURIComponent(item.handle);
    link.className = 'link';
    link.textContent = this.viewProductLabel || 'Voir le produit';
    box.append(text,link,removeControl.call(this, item));
    return box;
  }
  function start(el) {
    if (el.dataset.lgInit) return;
    el.dataset.lgInit = '1';
    const grid = el.querySelector('[data-lg-grid]');
    const form = el.querySelector('[data-lg-add]');
    const input = form && form.querySelector('[name=product]');
    const empty = el.querySelector('[data-lg-empty]');
    const count = el.querySelector('[data-lg-count]');
    const status = el.querySelector('[data-lg-status]');
    const reset = el.querySelector('[data-lg-reset]');
    if (!grid || !form || !input || !empty || !count || !status || !reset) return;
    const speak = message => {status.textContent = message || '';};
    const labels = {
      removeLabel: el.dataset.lgRemoveLabel,
      unavailableLabel: el.dataset.lgUnavailableLabel,
      viewProductLabel: el.dataset.lgViewProductLabel
    };
    function appendAction(node, item) {
      // Le coeur sur la carte permet le retrait du favori.
      // Garder une action de retrait seulement quand la carte est indisponible.
      if (!node.querySelector('.product-card__info')) return unavailable.call(labels, item);
      return node;
    }
    let generation=0,busy=false;
    async function render() {
      const current=++generation;
      const items=read();
      empty.hidden=items.length>0;
      count.textContent=items.length + ' ' + (items.length===1 ? el.dataset.lgCountOne : el.dataset.lgCountMany);
      if (!items.length) {grid.replaceChildren();speak('');return;}
      speak(el.dataset.lgLoadingLabel || 'Chargement des favoris…');
      const cards=await Promise.all(items.map(async item => {
        try {
          const base=await ajaxCard(item);
          return appendAction(base, item);
        } catch(e) {return unavailable.call(labels, item);}
      }));
      if (current !== generation) return;
      grid.replaceChildren(...cards);
      speak('');
    }
    reset.addEventListener('click',() => {
      if(!save([])){speak('Impossible de vider la sélection sur cet appareil.');return;}
      render();
    });
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if (busy) return;
      const entry=parse(input.value);
      if(!entry){speak('Utilise une URL de produit de la boutique ou son identifiant.');return;}
      busy=true;
      const button=form.querySelector('[type=submit]');
      if(button)button.disabled=true;
      speak('Vérification du produit…');
      try {
        const response=await fetch(ROOT + 'products/' + encodeURIComponent(entry.handle) + '.js',{credentials:'same-origin'});
        if(!response.ok)throw new Error('Produit introuvable.');
        const product=await response.json();
        const variants=Array.isArray(product.variants)?product.variants:[];
        const selected=(entry.variant && variants.find(v=>String(v.id)===entry.variant)) ||
          variants.find(v=>v.available) || variants[0];
        if(!selected)throw new Error('Ce produit ne possède aucune variante.');
        const item={handle:entry.handle,variant_id:String(selected.id),added_at:new Date().toISOString()};
        if(ID.test(String(product.id || ''))) item.product_id=String(product.id);
        const items=read();
        if(items.some(x=>key(x)===key(item))){speak('Cette variante est déjà dans ta sélection.');return;}
        if(items.length>=LIMIT)throw new Error('La sélection est limitée à '+LIMIT+' produits.');
        items.unshift(item);
        if(!save(items))throw new Error('Enregistrement local bloqué par le navigateur.');
        input.value='';
        await render();
      } catch(e) {speak(e.message||'Impossible d’ajouter ce produit.');}
      finally {busy=false;if(button)button.disabled=false;}
    });
    window.addEventListener('lg:wishlist-lab:changed', () => {
      if (!document.contains(el)) return;
      render();
    });
    window.addEventListener('lg:wishlist-lab:error', event => {
      if (!document.contains(el)) return;
      speak(event.detail?.message || 'Impossible de modifier la sélection.');
    });
    grid.addEventListener('click',event=>{
      const button=event.target.closest('button[data-lg-remove]');
      if(!button || !grid.contains(button))return;
      const items=read().filter(x=>key(x)!==button.dataset.lgRemove);
      if(!save(items)){speak('Suppression impossible sur cet appareil.');return;}
      render();
    });
    render();
  }
  function boot(){document.querySelectorAll('[data-lg-wishlist-lab]').forEach(start);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();